import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: guardMyroute,
  },
  {
    path: '/evaluador/:recording_id?',
    name: 'Evaluador',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/Evaluador.vue'),
    beforeEnter: guardMyroute,
  },
  {
    path: '/reports/',
    name: 'Reportes',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/Reports.vue')
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/auth/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

function guardMyroute(to, from, next) {
  let isAuthenticated = false

  //this is just an example. You will have to find a better or 
  // centralised way to handle you localstorage data handling
  // console.log(localStorage.getItem('user'));
  if (localStorage.getItem('user-token')) {
    isAuthenticated = true
  } else {
    isAuthenticated = false
  }
  if (isAuthenticated) {
    return next() // allow to enter route
  } else {
    return next('/login') // go to '/login';
  }
}

export default router